var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 211.34",
    height: 57,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 9px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#fff",
    points: "149.59 148 149.59 4.5 53.36 4.5 53.36 53.36 4.5 53.36 4.5 192.26 96 192.26"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 53.36,
    y1: 5.11,
    x2: 4.5,
    y2: 53.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    stroke: "#fff",
    x: 114.5,
    y: 165,
    width: 71,
    height: 41.84,
    rx: 6,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#fff",
    d: "M150,191.71l-35.5-24.04c0-.74,.28-1.41,.73-1.89s1.07-.78,1.75-.78h66.05c.68,0,1.3,.3,1.75,.78s.73,1.15,.73,1.89l-35.5,24.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.34,121.49v-35.62c1.98,0,8.14-.1,10.89-.1,10.84,0,14.4,5.65,14.4,11.81s-4.94,11.96-13.18,11.96c-.76,0-2.7,0-3.97-.15v12.11h-8.14Zm8.14-27.99v8.14c1.17,.15,2.54,.25,3.71,.25,2.14,0,4.78-.92,4.78-4.38,0-3.16-2.04-4.12-4.94-4.12-1.07,0-1.88,.05-3.56,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.29,85.87h.71c1.88,0,8.19-.15,10.53-.15,14.25,0,20,8.19,20,17.66,0,9.97-6.82,18.22-20.41,18.22-1.88,0-6.56-.1-9.97-.1h-.87v-35.62Zm8.14,7.63v20.36c1.07,.1,1.78,.1,2.95,.1,7.02,0,11.5-3.82,11.5-10.58s-4.83-10.02-11.45-10.02c-.87,0-1.98,0-3,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.2,85.87h20.61v7.63h-12.47v7.53h10.94v7.63h-10.94v12.82h-8.14v-35.62Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step5.fea83e81ad952e342382b91bfd56926d.svg";
export { ForwardRef as ReactComponent };